import { Loader2 } from 'lucide-react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
  className?: string
  showLogo?: boolean
}

export default function LoadingSpinner({ 
  size = 'md', 
  text = 'Loading...', 
  className = '',
  showLogo = true
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  }

  if (showLogo && size === 'lg') {
    // Splash screen with logo
    return (
      <div className={`flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 ${className}`}>
        <div className="flex flex-col items-center space-y-6">
          <div className="relative">
            <img 
              src="/logo.png" 
              alt="MindSpire Planner" 
              className="h-24 w-24 rounded-full shadow-lg animate-pulse"
            />
          </div>
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              MindSpire Planner
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Intelligent Educational Schedule Management
            </p>
          </div>
          <div className="flex items-center space-x-2 mb-8">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
            <span className="text-sm text-muted-foreground">{text}</span>
          </div>
          
          {/* Powered by Java Mantra Corp */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
            <div className="text-center">
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-1">
                Powered by
              </p>
              <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                Java Mantra Corp.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`flex flex-col items-center justify-center min-h-screen ${className}`}>
      <Loader2 className={`animate-spin text-primary ${sizeClasses[size]}`} />
      {text && (
        <p className="mt-4 text-sm text-muted-foreground">{text}</p>
      )}
    </div>
  )
}